import React, { useEffect, useState } from "react";
import "./PackagesCardList.css";
import { Col, Row } from "react-bootstrap";
import { ParentPackageCard } from "../../index";
import { Paginations, SpinnerLoading } from "../../../../components/index";
import { axiosGet } from "../../../../utils/apis/api";
import { NotFound } from "../../../../components"

const PackagesCardList = ({errorNotFound,  pageDataList, url }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const resultsPerPage = 6;

 

  useEffect(() => {
    if (pageDataList) {
      setData(pageDataList?.categories ?? [])
      setCurrentPage(pageDataList.pagination?.metadata?.current_page)
      setTotalPages(pageDataList.pagination?.metadata?.total_pages)
    }

  }, [pageDataList])


  const fetchData = async (pageNumber = 1) => {
    try {

      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/alltimes.www.api.package_categories?start=${start}&limit=${resultsPerPage}`;

      setIsLoading(true);
      const response = await axiosGet(apiUrl);

      const result = response.result;
      setCurrentPage(result.pagination.metadata.current_page);
      setTotalPages(result.pagination.metadata.total_pages);
      setData(result.categories);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      return { data: null, error: error.message };

    }
  };





  const onPageChange = (pageNumber) => {
    fetchData(pageNumber);
  };

  if (isLoading) {
    return (
      <div className='loading-container'>
        <SpinnerLoading />
      </div>
    );
  }

  

  return (
    <>
    
      {
        errorNotFound ? (
          <NotFound
            errorCode={String(errorNotFound.code)}
            errorMessage={String(errorNotFound.message)}
            description={String(errorNotFound.description)}
          />
        ) : (
          <div className="PackagesCardList-container">
            <Row>
              {
                data.map((item, index) => {
                  // if (item.total_packages !== 0) {
                    return (
                      <Col key={index} lg={4} md={6} sm={12} className="PackagesCardList-col" >
                        <ParentPackageCard pageData={item} url={url} />
                      </Col>
                    );
                  // } else {
                  //   return null;
                  // }
                })
              }
            </Row>
            <div className="d-flex justify-content-center mt-5">
              <Paginations
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        )
      }
    </>
    
   
  );
};

export default PackagesCardList;
